// @flow
import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '../../customer-form/get-phone-number-normalizer';

const BOLIVIA: Country = {
  code: 'bo',
  customerForm: {
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(20),
    },
  },
};

export default BOLIVIA;
